module.exports = __webpack_public_path__ + "img/gallery-image-28.9b61911b.jpg";